import { connect } from 'react-redux'
import { Component } from "react"
import { useState } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import {word3D}  from '../game/loader';
import UserAdminInterface from './UI'
import UserInterface from "./UserInterface"
import {useCookies} from 'react-cookie'
import {onMouseLngLatPositionAction} from '../actions'
import{getBoundingRec} from "../game/help"
import {
  
  LoadingOverlay
} from "@mantine/core";
import WordObjects from './UI3D/WordObjects';
//#13/23.17418/43.11008/-45/45
const center = [43.11008, 23.17418]
const zoomFact = 1
let _3D_ok = false
let _3D_loading_ok = false


let objectsScene = {}

const placeZoom = (gltf, scale, z) => {
    if(!scale) return
    z = Math.floor(z)
    if(scale.x){ 
        gltf.scene.scale.set(scale.x, scale.y, scale.z)
    }
    else
    if(scale[z]){ 
      gltf.scene.scale.set(scale[z].x, scale[z].y, scale[z].z)
    }
    else{
        for(z; z < 20; z++){
          if(scale[z]){ 
            gltf.scene.scale.set(scale[z].x, scale[z].y, scale[z].z)
            break
          }
        }
    }
  }

const loadword = async (scene3D)=>{

    const objectsScene = {}
    const uri = "/get/3d/word"
    try{ 
        const response = await fetch(uri, {
            method: "GET",
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            }
        })
        if(response.status === 200) { 
            const datas = await response.json();
            for(let i=0; i < datas.length; i ++){
                const obj = datas[i]
                let {x: x, y:y, z:z} = scene3D.map.getPosition3D(obj.lnglat)
                const loader = new GLTFLoader();
                const file = `/${obj.mesh3d.filename}`
                const gltf = await loader.loadAsync(file)                 
                console.log("World3D.loadword", i, obj.uid, obj.mesh3d.nom, obj.lnglat, obj)

                gltf.boundings = getBoundingRec(gltf.scene)

                if(obj.parameters === null) obj.parameters = {}
               
                const params = {
                    scale: obj.parameters.scale || obj.mesh3d.parameters.scale,
                    rotate: obj.parameters.rotate || obj.mesh3d.parameters.rotate,
                    y:  obj.parameters.y || obj.mesh3d.parameters.y,
                }
                if(obj.uid === "2a3ab57b-e789-4566-b2bc-4b850cd96de6"){
                    console.log(obj)
                }
                if(params){
                    if(params.scale){
                        placeZoom(gltf, params.scale, scene3D.map.getZoom())
                    }
                    
                    if(params.rotate){
                        gltf.scene.rotation.set(params.rotate.x, params.rotate.y, params.rotate.z)
                    }

                    if(params.y){
                        y += params.y
                    }
                }

                gltf.scene.position.set(x, y, z)

                const t = obj.mesh3d.type
                if(!objectsScene[t]){
                    objectsScene[t] = []
                }
                
                objectsScene[t].push({
                    element3D: obj.mesh3d,
                    uid: obj.uid,
                    gltf: gltf,
                    lngLat: new window.maplibregl.LngLat(obj.lnglat.lng , obj.lnglat.lat),
                    toSave: false
                })

                scene3D.scene.add(gltf.scene)


            }
            
            
        }

        return objectsScene

    } 
    catch(e){
        console.log("World3D.loadword error", e)
    }
    return {}
    
}


const pathContext = {
    scene3D: null,
    loading: false,
    objectsScene: {},
    currentSelection: null,
    currentHighlight:null,
    version: 0,
}
class World3D extends Component{

    constructor(props) {
        super(props)
        this.state = pathContext

        //
    }//


    makeStateCopy(){
        return {
            scene3D: this.state.scene3D,
            loading: this.state.loading,
            objectsScene: this.state.objectsScene,
            currentSelection: this.state.currentSelection,
            currentHighlight: this.state.currentHighlight,
            version: this.state.version + 1
        }
    }

    getCollisionObject(lngLat){
        const state = this.makeStateCopy()
        if(!state.scene3D || !state.scene3D.map) return undefined

        let last = 1000000000
        let c = undefined 
        for(let k in this.state.objectsScene){ 
            const objectsScene = this.state.objectsScene[k]
            for(let i=0; i < objectsScene.length; i ++){
                const obj = objectsScene[i]
                
                if(!obj || !obj.gltf) continue

                let is_select = false
                for(let s=0; s<obj.gltf.scene.children.length; s ++){
                    const child = obj.gltf.scene.children[s]
                    if(child.name === "Highlight"){
                        obj.gltf.scene.remove(child)
                    }
                    if(child.name === "Selection"){
                        is_select = true
                    }
                }
                if(is_select) continue
                let box
                let boxSize = -100
                obj.gltf.scene.traverse( function ( child ){
                    if ( child.isMesh )
                    {
                    const b = new THREE.Box3().setFromObject(child);
                    
                    const s = b.getSize(new THREE.Vector3()).length();
                    if(s > boxSize){
                        boxSize = s
                        box = b
                    }
                    
                    }
                });
                if(box){ 
                    const v = box.getCenter(new THREE.Vector3())
                    //obj.gltf.scene.localToWorld(v);
                    //const z = v.z 
                    v.z = v.y;
                    //v.x = z;
                    v.y = 0;
    
                    const s = 2*(box.getSize(new THREE.Vector3()).length()/2)/3;
                    const {x: x, y:y, z:z} = state.scene3D.map.getPosition3D(lngLat)
                    const p = new THREE.Vector3(x, y, z)
                    const lx = (box.max.x - box.min.x)
                    const lz = (box.max.z - box.min.z)
                    let r = lx
                    if(r > lz){
                     r = lz
                    }
                    r /= 2
                    const d = p.distanceTo(v)
                    if(d <= s){
                        if(d < last){ 
                            c = obj
                            last = d
                        }
                    }
                }
            }
        }
        return c
    }


    onMouseMove(msg){
        const state = this.makeStateCopy()
        if(!state.scene3D || !state.scene3D.map) return
        if(state.currentHighlight ){
            state.currentHighlight.obj.gltf.scene.remove(state.currentHighlight.cube)
            state.currentHighlight = null
        }

        const o = this.getCollisionObject(msg.lngLat)
        if(o){
            state.currentHighlight = {}
            state.currentHighlight.obj = o

            const dx = o.gltf.boundings.boundingRect.max.x - o.gltf.boundings.boundingRect.min.x
            const dy = o.gltf.boundings.boundingRect.max.y - o.gltf.boundings.boundingRect.min.y
            const dz = o.gltf.boundings.boundingRect.max.z - o.gltf.boundings.boundingRect.min.z
    
            const center = o.gltf.boundings.boundingRect.getCenter(new THREE.Vector3())
            const gltf = state.currentHighlight.obj.gltf
            const geometry = new THREE.BoxGeometry( dx, dy, dz );
            const edgesGeometry = new THREE.EdgesGeometry( geometry );
            const material = new THREE.LineBasicMaterial({color: 0x00ff00});
    
            const edges = new THREE.LineSegments( edgesGeometry, material );
            edges.name = "Highlight"
    
            state.currentHighlight.cube = edges
            edges.position.set(center.x, center.y, center.z)
            //edges.scale.set(gltf.scene.scale.x, gltf.scene.scale.y, gltf.scene.scale.z)
            //cube.update();
            
            gltf.scene.add(edges)
        }
        this.setState(state)
    }
    onMouseUp(msg){
        const state = this.makeStateCopy()

        /*if(state.currentSelection && !this.props.pathSelected)
        {
            state.currentSelection.obj.gltf.scene.remove(state.currentSelection.cube)
            state.currentSelection = null
        }*/

        if(state.currentSelection && state.currentSelection.cube){
            state.currentSelection.obj.gltf.scene.remove(state.currentSelection.cube)
        }

        const o = this.getCollisionObject(msg.lngLat)
        if(o){
            if(state.currentSelection && state.currentSelection.cube){
                state.currentSelection.obj.gltf.scene.remove(state.currentSelection.cube)
            }
            state.currentSelection = {}
            state.currentSelection.obj = o

            const dx = o.gltf.boundings.boundingRect.max.x - o.gltf.boundings.boundingRect.min.x
            const dy = o.gltf.boundings.boundingRect.max.y - o.gltf.boundings.boundingRect.min.y
            const dz = o.gltf.boundings.boundingRect.max.z - o.gltf.boundings.boundingRect.min.z
    
            const center = o.gltf.boundings.boundingRect.getCenter(new THREE.Vector3())
            const gltf = state.currentHighlight.obj.gltf
            const geometry = new THREE.BoxGeometry( dx, dy, dz );
            const edgesGeometry = new THREE.EdgesGeometry( geometry );
            const material = new THREE.LineBasicMaterial({color: 0x4F00FF});
    
            const edges = new THREE.LineSegments( edgesGeometry, material );
            edges.name = "Selection"
    
            state.currentSelection.cube = edges
            edges.position.set(center.x, center.y, center.z)
            
            gltf.scene.add(edges)

            this.props.notification.onNotification("ObjectSelection", {selection: state.currentSelection.obj}, {})
        }
        this.setState(state)

    }
    isComponentMount = false
    async componentDidMount() {
        if(this.isComponentMount) return
        this.isComponentMount = false
        this.props.notification.addNotification("Object3DClearSelection", async (type, msg, arg)=>{
            const state = this.makeStateCopy()
            if(state.currentSelection)
            {
                state.currentSelection.obj.gltf.scene.remove(state.currentSelection.cube)
                state.currentSelection = null
            }
            this.setState(state)
        })

        this.props.notification.addNotification("Loading", (type, msg, arg)=>{
            let state = this.makeStateCopy()
            state.loading = msg.loading
            this.setState(state)
        })

        this.props.notification.addNotification("Scene3D", async (type, msg, arg)=>{
            if(msg.container !== "map-world") return

            if(!_3D_loading_ok && arg){
                _3D_loading_ok = true
                setTimeout(async ()=>{
                    let state = this.makeStateCopy()
                    state.loading = true
                    this.setState(state)
                    const l = await loadword(arg)
                    state.objectsScene = l
                    state.loading = false
                    this.setState(state)
                }, 1)

                let state = this.makeStateCopy()
                state.scene3D = arg
                this.setState(state)

                this.props.notification.addNotification("mousemove", (type, msg, arg)=>{
                    this.onMouseMove(msg)
                })

                this.props.notification.addNotification("mouseup", (type, msg, arg)=>{
                    this.onMouseUp(msg)
                })

                this.props.notification.addNotification("Object3DParametresChange", (type, msg, arg)=>{
                    if(this.state.objectsScene[msg.type]){
                        let tosave = 0
                        for(let i=0; i < this.state.objectsScene[msg.type].length; i ++){
                            const obj = this.state.objectsScene[msg.type][i]
                            if(obj.uid === msg.element_id){
                                obj.toSave = true
                                tosave ++
                                if(msg.parameters.lngLat){
                                    obj.lngLat = msg.parameters.lngLat
                                    delete msg.parameters.lngLat
                                    obj.parameters = msg.parameters
                                }
                                
                            }
                            
                        }
                        if(tosave>0){
                           this.props.notification.onNotification("SaveIndicator", {nb: tosave}, {})
                        }
                    }

                })
            }
        })

        if(!_3D_ok){
            word3D(center, this.props, "map-world")
            _3D_ok = true
        }
    }
    

    render() { 
        return (
            <>
                <LoadingOverlay visible={this.state.loading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
                { this.props.cookies.user.is_admin === true ? (
                        <UserAdminInterface objectsScene={this.state.objectsScene} objectSelection={this.state.currentSelection}/>): ""
                }
                { this.props.cookies.user.is_admin === false ? (
                    <UserInterface   user={this.props.cookies.user}   objectsScene={this.state.objectsScene} objectSelection={this.state.currentSelection}/>): ""
                }

                <div id="map-world"></div>
            </>
        )
    }

}

const mapDispatchToProps = {
    onMouseLngLatPositionAction: onMouseLngLatPositionAction
}


const mapStateToProps = (state) => {  
    return {
        notification: state ? state.notification : undefined,
        pathSelected: state.pathSelected
    }
}


World3D = connect(mapStateToProps, mapDispatchToProps)(World3D);

export default World3D;